module.exports = __webpack_public_path__ + "static/assets/760d0705f712e26ddf2357e165976946.png";